import { onResizeStop } from '../lib/utils';

export default class MasonryGrid {
  constructor({ el }) {
    this.el = el;
    this.items = Array.from(this.el.querySelectorAll('.grid-item'));
    this.columns = Array.from(this.el.querySelectorAll('.grid-col'));

    this.init();
  }

  init() {
    this.distributeItems();

    onResizeStop(this.distributeItems);
  }

  distributeItems() {
    // Clear existing content in grid-cols
    this.columns.forEach((col) => (col.innerHTML = ''));

    // Get visible columns
    const visibleCols = this.columns.filter((col) => {
      return window.getComputedStyle(col).display !== 'none';
    });

    // Distribute items sequentially across columns
    for (let i = 0; i < this.items.length; i++) {
      const col = visibleCols[i % visibleCols.length];
      col.appendChild(this.items[i]);
    }

    if (!this.el.classList.contains('active')) {
      this.el.classList.add('active');
    }
  }
}
